<nz-layout class="app-layout" *ngIf="isReady">
  <nz-sider class="sidebar" nzCollapsible nzWidth="208px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <app-side-navbar [isCollapsed]='isCollapsed'></app-side-navbar>
  </nz-sider>
  <nz-layout>
    <nz-header class="header-wrap">
      <app-top-navbar (handleCollapsed)="handleCollapsed($event)"></app-top-navbar>
    </nz-header>


    <nz-content class="content-wrapper">
      <div class="inner-content">
        <router-outlet>
          <div nz-col nzSpan="8" *ngIf="langueBooleanCN  && Routerurl">
            <nz-card style="width: 88vw;">
              <div class="Rules2">
                <nz-collapse nzGhost>
                  <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="panel.noticeTitle" nzActive="true"
                    class="collapse" style="color: rgb(0, 0, 0);">
                    <p class="testDiv" style="font-weight:normal">
                      {{panel.chNoticeDetail}}
                    </p>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </nz-card>
          </div>

          <div nz-col nzSpan="8" *ngIf="langueBooleanTW && Routerurl">
            <nz-card style="width: 88vw;">
              <div class="Rules2">
                <nz-collapse nzGhost>
                  <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="panel.twNoticeTitle" nzActive="true"
                    class="collapse">
                    <p class="testDiv" style="font-weight:normal">
                      {{panel.twNoticeDetail}}
                    </p>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </nz-card>
          </div>

          <div nz-col nzSpan="8" *ngIf="langueBooleanEN && Routerurl">
            <nz-card style="width: 88vw;">
              <div class="Rules2">
                <nz-collapse nzGhost>
                  <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="panel.enNoticeTitle" nzActive="true"
                    class="collapse">
                    <p class="testDiv" style="font-weight:normal">
                      {{panel.enNoticeDetail}}
                    </p>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </nz-card>
          </div>

          <div nz-col nzSpan="8" *ngIf="langueBooleanVN && Routerurl">
            <nz-card style="width: 88vw;">
              <div class="Rules2">
                <nz-collapse nzGhost>
                  <nz-collapse-panel *ngFor="let panel of listtimedata" [nzHeader]="panel.vnNoticeTitle" nzActive="true"
                    class="collapse">
                    <p class="testDiv" style="font-weight:normal">
                      {{panel.vnNoticeDetail}}
                    </p>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </nz-card>
          </div>

        </router-outlet>
      </div>
    </nz-content>



  </nz-layout>
</nz-layout>

<nz-spin [nzSpinning]="!isReady" nzTip="Loading user information...">
  <div style="height: 100vh;width: 100vw;"></div>
</nz-spin>